import React, { useState, useEffect } from "react";
import { Row, Col, Card, message, Divider, Table, Typography, Space, Tag } from "antd";
import { FileDoneOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

export const AvaliacoesResultadosDescritivasDetalhes = () => {
  const { id_avaliacao } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  useEffect(() => {
    if (id_avaliacao > 0) {
      carregarAvaliacaoResultado(id_avaliacao);
    }
  }, [id_avaliacao]);

  // LISTAR
  const carregarAvaliacaoResultado = async (idAvaliacao) => {
    if (!idAvaliacao) return;
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_formularios_lancamento/carregar_resultado_descritivas`, {
      id_avaliacao: idAvaliacao,
    });
    if (api.statusCode === 200) {
      if (!api?.response?.data?.id) {
        navigate("/avaliacoes/resultados_descritivas");
      }
      setDados(api?.response?.data);
    } else {
      navigate("/avaliacoes/resultados_descritivas");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns_descritivas = [
    {
      dataIndex: "descricao",
      title: "Descrição",
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/avaliacoes/resultados_descritivas")} />
            <HeaderTitle
              title="Avaliações Resultado Descritivas Detalhes"
              subtitle="Resultado da avaliação"
              icon={<FileDoneOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Row>
                <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
                  <Space direction="vertical" size={0}>
                    <Text type="secondary" style={{ fontSize: 14 }}>
                      Avaliação
                    </Text>
                    <Text strong style={{ fontSize: 16 }}>
                      {dados?.avaliacao}
                    </Text>
                  </Space>
                </Col>
                <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
                  <Space direction="vertical" size={0}>
                    <Text type="secondary" style={{ fontSize: 14 }}>
                      Ano
                    </Text>
                    <Text strong style={{ fontSize: 16 }}>
                      {dados?.ano}
                    </Text>
                  </Space>
                </Col>
              </Row>
              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns_descritivas}
                dataSource={dados?.grupos_descritivas}
                pagination={false}
                size="small"
                rowKey="id"
                expandable={{
                  expandRowByClick: true,
                  expandedRowRender: (e) =>
                    e?.questoes?.map((quest) => (
                      <Space key={quest?.id} direction="vertical">
                        <Text strong>{quest?.descricao}</Text>
                        <Space wrap align="start">
                          {quest?.respostas?.map((e) => (
                            <Card
                              key={e?.id}
                              style={{ borderStyle: "dashed", borderWidth: 2, width: "100%", maxWidth: 450 }}
                              bodyStyle={{ padding: 15 }}>
                              <Space direction="vertical" className="line-break">
                                {e.resposta}
                                {e?.autoavaliacao === 1 && <Tag color="green">Autoavaliação</Tag>}
                              </Space>
                            </Card>
                          ))}
                        </Space>
                      </Space>
                    )),
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
